import axios from 'axios';

export class ErrorHelper {
    static handle(e: unknown): void {
        if (axios.isAxiosError(e)) {
            // TODO: Create modal to show default error message
        }
    }
}
